import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Alert,
  Button,
  Label,
} from "reactstrap";
import { DataTable, TableRowField, ExportCSV } from "../../../../components";
import { getEmployeesBalance } from "../../../../store/report/actions";
import { messages, layout, roles } from "../../../../common/constants";
import MediaQuery from "react-responsive";
import { formatHelper } from "../../../../common/helpers";
import "react-dates/initialize";
import { DateRangePicker } from "react-dates";
import "react-dates/lib/css/_datepicker.css";
import { getEmployeesBalance as employeesBalanceExport } from "../../../../service/report";
import { getStores } from "../../../../store/store/actions";
import { selectUserRole } from "../../../../store/user/selector";
import { selectStoresForSelect } from "../../../../store/store/selector";
import Select from "react-select";
import moment from "moment";
import DatePicker from "react-datepicker";
import { exportExcel } from "./excel";

class EmployeesBalance extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedDate: null,
      startDate: null,
      endDate: null,
      focusedInput: null,
      page: 1,
      showTopEmployees: true,
      loadingExport: false,
      selectedStore: null,
    };
    this.handleObtainReportExport = this.handleObtainReportExport.bind(this);

    this.handleStoreChange = this.handleStoreChange.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
  }

  handleEmployeesBalanceDateChange(startDate, endDate) {
    this.setState({ startDate, endDate });

    if (startDate != null && endDate != null) {
      this.props.getEmployeesBalance({
        page: this.state.page,
        startDate: startDate._d,
        endDate: endDate._d,
        store: this.state.selectedStore.value,
      });
    }
  }

  handleDateChange(selectedDate) {
    this.setState({ selectedDate });
    if (selectedDate != null) {
      this.props.getEmployeesBalance({
        page: this.state.page,
        startDate: selectedDate._d,
        endDate: selectedDate._d,
        store: this.state.selectedStore.value,
      });
    }
  }

  async handleStoreChange(value) {
    if (value == this.state.selectedStore) return;
    await this.setState({ selectedStore: value, page: 1 });

    if (
      this.state.startDate &&
      this.state.endDate &&
      this.state.selectedStore
    ) {
      this.performGetEmployeesBalance();
    }
  }

  async componentDidMount() {
    await this.setState({ selectedDate: moment() });
    await this.props.getStores({ reset: true });
    //await this.performGetEmployeesBalance(true)
  }

  async componentDidUpdate(prevProps) {
    if (prevProps.stores.length == 0 && this.props.stores.length > 0) {
      await this.setState({ selectedStore: this.props.stores[0] });
      this.handleDateChange(this.state.selectedDate);
    }
  }

  performGetEmployeesBalance(reset = false) {
    const { getEmployeesBalance } = this.props;
    const { page } = this.state;
    const store = this.state.selectedStore.value;

    getEmployeesBalance({
      page,
      startDate: this.state.startDate._d,
      endDate: this.state.endDate._d,
      store,
      reset,
    });
  }

  async handlePageChange(page) {
    await this.setState({ page: page });
    this.performGetEmployeesBalance();
  }

  renderDataTable(columns) {
    return (
      <DataTable
        data={this.props.employeesBalance}
        keyField="id"
        columns={columns}
        page={this.state.page}
        totalSize={this.props.total}
        sizePerPage={this.props.pageSize}
        loading={this.props.loading}
        onPageChange={this.handlePageChange}
      />
    );
  }

  handleObtainReportExport() {
    this.setState({ loadingExport: true });
    const { startDate, endDate, selectedStore } = this.state;
    employeesBalanceExport(0, startDate._d, endDate._d, selectedStore.value)
      .then((response) => {
        exportExcel(response.data.data, selectedStore, startDate, endDate);
      })
      .finally(() => {
        this.setState({ loadingExport: false });
      });
  }

  render() {
    const columnsXS = [
      {
        dataField: "xs",
        text: "Balance por Empleado",
        formatter: (cell, row) => {
          return (
            <div>
              <TableRowField
                label="Empleado:"
                value={`${row.name} ${row.lastname}`}
              />
              <TableRowField
                label="Servicios (S/):"
                value={formatHelper.toMoney(row.totalSoldServices)}
              />
              <TableRowField
                label="Productos (S/):"
                value={formatHelper.toMoney(row.totalSoldProducts)}
              />
              <TableRowField
                label="Ofertas (S/):"
                value={formatHelper.toMoney(row.totalSoldOffers)}
              />
              <TableRowField label="Total (S/):" value={row.totalSold} />
            </div>
          );
        },
      },
    ];
    const columnsSM = [
      {
        dataField: "xs",
        text: "Balance por Empleado",
        formatter: (cell, row) => {
          return (
            <div>
              <TableRowField
                label="Empleado:"
                value={`${row.name} ${row.lastname}`}
              />
              <TableRowField
                label="Servicio (S/):"
                value={formatHelper.toMoney(row.totalSoldServices)}
              />
              <TableRowField
                label="Productos (S/):"
                value={formatHelper.toMoney(row.totalSoldProducts)}
              />
              <TableRowField
                label="Ofertas (S/):"
                value={formatHelper.toMoney(row.totalSoldOffers)}
              />
            </div>
          );
        },
      },
      {
        dataField: "total",
        text: "Total (S/)",
        style: { width: "180px" },
        headerStyle: { width: "180px" },
        formatter: (cell, row) => {
          return (
            <div>
              <TableRowField
                label=""
                value={formatHelper.toMoney(row.totalSold)}
              />
            </div>
          );
        },
      },
    ];
    const columnsMD = [
      {
        dataField: "employee",
        text: "Empleado",
        formatter: (cell, row) => {
          return (
            <div>
              <TableRowField
                label=""
                value={`${row.name} ${row.lastname}`}
              ></TableRowField>
            </div>
          );
        },
      },
      {
        dataField: "totalSoldServices",
        text: "Servicios (S/)",
        formatter: (cell, row) => {
          return (
            <div>
              <TableRowField
                label=""
                value={formatHelper.toMoney(row.totalSoldServices)}
              />
            </div>
          );
        },
      },
      {
        dataField: "totalSoldProducts",
        text: "Productos (S/)",
        formatter: (cell, row) => {
          return (
            <div>
              <TableRowField
                label=""
                value={formatHelper.toMoney(row.totalSoldProducts)}
              />
            </div>
          );
        },
      },
      {
        dataField: "totalSoldOffers",
        text: "Ofertas (S/)",
        formatter: (cell, row) => {
          return (
            <div>
              <TableRowField
                label=""
                value={formatHelper.toMoney(row.totalSoldOffers)}
              />
            </div>
          );
        },
      },
      {
        dataField: "totalSold",
        text: "Total (S/)",
        formatter: (cell, row) => {
          return (
            <div>
              <TableRowField
                label=""
                value={formatHelper.toMoney(row.totalSold)}
              />
            </div>
          );
        },
      },
    ];
    const { startDate, endDate } = this.state;
    return (
      <div>
        <Card>
          <CardHeader
            onClick={() =>
              this.setState({ showTopEmployees: !this.state.showTopEmployees })
            }
          >
            <i className="icon-chart"></i>Balance por Empleado
          </CardHeader>
          <CardBody>
            <div>
              {(this.props.role == roles.SUPER_ADMIN ||
                this.props.role == roles.ADMIN) && (
                <Row className="my-4">
                  <Col sm="1">
                    <Label className="mt-2">Tienda:</Label>
                  </Col>

                  <Col sm="4">
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      isLoading={this.props.loadingStores}
                      isSearchable={true}
                      noOptionsMessage={() => {
                        return messages.SELECT_NO_OPTIONS;
                      }}
                      placeholder=""
                      options={this.props.stores}
                      loadingMessage={() => {
                        return messages.SELECT_LOADING;
                      }}
                      onChange={this.handleStoreChange}
                      value={this.state.selectedStore}
                      isDisabled={
                        this.props.loadingStores || this.props.loading
                      }
                    />
                  </Col>
                </Row>
              )}
              <hr className="my-4" />
              <Row className="mb-2">
                <Col md="12">
                  <DateRangePicker
                    startDate={startDate}
                    startDateId="startDate"
                    endDate={endDate}
                    endDateId="endDate"
                    displayFormat={"DD/MM/YYYY"}
                    disabled={this.props.loadingStores || this.props.loading}
                    onDatesChange={({ startDate, endDate }) =>
                      this.handleEmployeesBalanceDateChange(startDate, endDate)
                    }
                    focusedInput={this.state.focusedInput}
                    onFocusChange={(focusedInput) =>
                      this.setState({ focusedInput })
                    }
                    startDatePlaceholderText="Fecha Inicio"
                    endDatePlaceholderText="Fecha Fin"
                    small
                    isOutsideRange={() => false}
                    hideKeyboardShortcutsPanel
                    minimumNights={0}
                  />
                  {(this.state.startDate && this.state.endDate) ||
                  this.state.selectedDate ? (
                    <ExportCSV
                      disabled={this.state.loadingExport}
                      exportCSV={this.handleObtainReportExport}
                    />
                  ) : null}
                </Col>
              </Row>
            </div>
            <hr className="my-4" />
            {
              // ((startDate != null && endDate != null) || selectedDate != null)
              startDate != null && endDate != null ? (
                <Row>
                  <Col>
                    <Row className="mb-2">
                      <Col>
                        <b>Total de Ventas (S/):</b>{" "}
                        {formatHelper.toMoney(this.props.totalSell)}
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <MediaQuery maxWidth={layout.XS_MAX_WIDTH}>
                          {this.renderDataTable(columnsXS)}
                        </MediaQuery>
                        <MediaQuery
                          minWidth={layout.SM_MIN_WIDTH}
                          maxWidth={layout.MD_MAX_WIDTH}
                        >
                          {this.renderDataTable(columnsSM)}
                        </MediaQuery>
                        <MediaQuery minWidth={layout.LG_MIN_WIDTH}>
                          {this.renderDataTable(columnsMD)}
                        </MediaQuery>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              ) : (
                <Row>
                  <Col>
                    <Alert color="info">
                      Seleccione un rango de fechas para visualizar los datos
                    </Alert>
                  </Col>
                </Row>
              )
            }
          </CardBody>
        </Card>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { employeesBalance, totalSell, total, pageSize, error, loading } =
    state.report.employeesBalanceList;

  return {
    employeesBalance,
    totalSell,
    total,
    pageSize,
    error,
    loading,
    role: selectUserRole(state),
    stores: selectStoresForSelect(state),
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getEmployeesBalance,
      getStores,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(EmployeesBalance);



// WEBPACK FOOTER //
// ./src/scenes/Report/Cash/EmployeesBalance/EmployeesBalance.js